import React from 'react';

const FaceProfilePage = React.lazy(() => import('pages/FaceProfile/FaceProfilePage'));
const FaceProfileReviewPage = React.lazy(() => import('pages/FaceProfile/FaceProfileReviewPage'));

const path = '/face-profile';
const permission = 'HR_FACEPROFILE_REVIEW';

const routers = [
  {
    path,
    exact: true,
    name: 'Duyệt khuôn mặt chấm công',
    function: permission,
    component: FaceProfilePage,
  },
  {
    path: `${path}/detail/:id`,
    exact: true,
    name: 'Chi tiết đăng ký khuôn mặt',
    function: permission,
    component: FaceProfileReviewPage,
  },
];

export default routers;
